import React from 'react';
import { Play, AlertCircle } from 'lucide-react';
import { Button } from '../../components/common/Button';

interface ActionButtonsProps {
  isLoading: boolean;
  isStartDisabled: boolean;
  isCancelling?: boolean;
  onStart: () => void;
  onCancel: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isLoading,
  isStartDisabled,
  isCancelling = false,
  onStart,
  onCancel
}) => {
  return (
    <>
    <div className="relative z-10 mt-6 md:mt-4 max-w-7xl w-full flex flex-col justify-center md:justify-end gap-4 px-0 mb-8 md:mb-0 md:px-0 mx-auto">
      { isStartDisabled && (
          <div className="flex flex-row justify-center items-center md:justify-end text-text-secondary-light dark:text-text-secondary-dark text-sm z-50">
            <AlertCircle className="w-4 h-4 mr-2" />
            <span className="items-center justify-center">Please enable your microphone to start the interview.</span>
          </div>
        )}
    <div className="relative z-10 pb-6 mt-2 max-w-7xl w-full flex flex-col-reverse md:flex-row justify-center md:justify-end gap-4 px-4 mb-8 md:mb-0 md:px-0 mx-auto">
      <Button 
        variant="outline" 
        onClick={onCancel}
        size="md"
        disabled={isCancelling}
        className="w-full md:w-auto px-8 transition-all duration-300 hover:bg-background-light dark:hover:bg-background-dark"
      >
        {isCancelling ? 'Closing...' : 'Cancel'}
      </Button>
      
      <Button 
        variant="primary" 
        size="md"
        leftIcon={<Play className="w-4 h-4" />}
        onClick={onStart}
        disabled={isLoading || isStartDisabled || isCancelling}
        className="w-full md:w-auto px-8 py-3.5 transition-all duration-300 hover:scale-105"
      >
        {isLoading && !isCancelling ? 'Preparing...' : 'Start Interview'}
      </Button>
    </div>
    </div>
    </>
  );
};

export default ActionButtons; 